export const CheckCircle = ({ className }: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM13.707 7.29297C13.3165 6.90244 12.6835 6.90244 12.293 7.29297L9 10.5859L7.70703 9.29297C7.31651 8.90244 6.68349 8.90244 6.29297 9.29297C5.90244 9.68349 5.90244 10.3165 6.29297 10.707L8.29297 12.707C8.68349 13.0976 9.31651 13.0976 9.70703 12.707L13.707 8.70703C14.0976 8.31651 14.0976 7.68349 13.707 7.29297Z"
        fill="currentColor"
      />
    </svg>
  )
}
